import { useEffect, useRef, useState } from 'react';
import DownloadIcon from '../svgs/Download';
import Style from './style.module.css'
import './style.css'
import './stylePortrait.css'
import './styleLandscape.css'
import Cruz from '../svgs/Cruz';

const InputRHF = ({
    dispositivo,
    type = "text",
    label,
    register = null,
    errors,
    resetField,
    campo,
    opciones,
    placeholder,
    setValue,
    watch,
    cols = 3,
    rows = 3,
    className,
    setImg,
    img,
    classRadio = 'd-flex gap-3 align-items-center',
    fase,
    widthInput

}) => {
    // const [imageSrc, setImageSrc] = useState(null);


    const fileInputRef = useRef(null);


    const handleDivClick = () => {
        if (fileInputRef.current)
            fileInputRef.current.click();
    };

    // Función para manejar el cambio de archivo
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setValue(campo, event.target.files)

        // Verificamos si hay un archivo seleccionado
        if (file) {
            const reader = new FileReader();

            // Cuando se termine de leer el archivo, actualizamos el estado con la URL de la imagen
            reader.onloadend = () => {
                // setImageSrc(reader.result);
                setImg(reader.result); // Guardamos la URL de la imagen en el estado
            };

            // Leemos el archivo como URL
            reader.readAsDataURL(file);
        }
    };

    

    return (
        <div className={className}>
            {label &&
                <label data-fase={fase} className={`${fase == "registrar" ? Style.labelRegistrar : fase == "ingreso" ? Style.labelIngreso : Style.label} `} htmlFor={campo} >{label}</label>}
            {
                type == "select"
                    ?
                    <div className={`${Style.containerSelect}`}>
                        <select className={`form-select ${Style.input} ${errors[campo] && "is-invalid"} ${errors[campo] && Style.errors}`} value={watch && watch(campo)} name={campo}
                            {...(register && { ...register(campo) })}
                        >
                            {placeholder && <option value={""}>{placeholder}</option>}
                            {
                                opciones?.map((opc, index) => {
                                    return (
                                        <option key={index} value={opc.value}>{opc.name}</option>
                                    )
                                })
                            }
                        </select>
                    </div>
                    : type == "textarea"
                        ?
                        <textarea className={`form-control ${Style.input} ${errors[campo] && "is-invalid"}`} name={campo} placeholder={placeholder} cols={cols} rows={rows} onChange={(e) => setValue(campo, e.target.value)}
                            {...(register && { ...register(campo) })}
                        />
                        : type == "radio"
                            ?
                            <div className={classRadio} style={{ minHeight: "35px" }}>
                                {opciones?.map((opc, index) => {
                                    return (
                                        <label className='d-flex gap-1' htmlFor={opc.id} key={opc.id}>
                                            <input type="radio" value={opc.value} id={opc.id} onChange={(e) => setValue(campo, e.target.value)}
                                                {...(register && { ...register(campo) })}
                                            />
                                            {opc.name}
                                        </label>
                                    )
                                })}
                            </div>
                            : type == "file"
                                ?

                                <div className=' w-100  rounded border-4 border-secondary d-flex justify-content-center align-items-center overflow-hidden' style={{ borderStyle: "dotted", height: "103px" }}
                                    onClick={handleDivClick}
                                >

                                    {img ? (

                                        <div className="image-preview h-100 w-100 position-relative">
                                            <div className='position-absolute bg-danger' style={{ right: "5px", top: "5px" }}
                                                onClick={() => {
                                                    setValue(campo, null)
                                                    setImg(null)
                                                }
                                                }
                                            >
                                                <Cruz height={'20px'} color={'#FFF'} />
                                            </div>

                                            <img src={img} alt="Vista previa" style={{ objectFit: "contain", width: "100%", height: "100%", display: "block" }} />

                                        </div>
                                    )
                                        :
                                        <>
                                            <div className='d-flex flex-column align-items-center'>
                                                <DownloadIcon color="#8B9298" width="35px" height="35px" />
                                                <p className='font-bold text-secondary'>Subir archivo</p>
                                            </div>
                                            <input
                                                type="file"
                                                ref={fileInputRef}
                                                style={{ display: 'none' }}
                                                onChange={handleFileChange}
                                                accept="image/*"
                                            />
                                        </>
                                    }

                                </div>
                                :
                                type == "number"
                                    ?
                                    <input
                                        data-fase={fase}
                                        onKeyDown={(e) => {
                                            // Evita las teclas no deseadas
                                            if (
                                                ["ArrowUp", "ArrowDown","e", "E", "+", "-", "." ].includes(e.key) // Permite un solo punto decimal
                                            ) {
                                                e.preventDefault();
                                            }

                                            
                                        }}
                                        onWheel={(e)=>{
                                            e.currentTarget.blur()
                                        }}
                                        autoComplete='off'
                                        onInput={(e) => {
                                            const value = e.target.value;
                                            if (value.length > 11 && campo == 'numero_tramite') {
                                                e.target.value = value.slice(0, 11); // Limita a 4 caracteres
                                            }
                                            if (value.length > 15 && campo == 'telefono') {
                                                e.target.value = value.slice(0, 15); // Limita a 15 caracteres
                                            }
                                            if (value.length > 8 && campo == 'documento') {
                                                e.target.value = value.slice(0, 8); // Limita a 15 caracteres
                                            }
                                        }} name={campo}
                                        style={{ width: widthInput && widthInput }}
                                        className={`  ${errors[campo] && "is-invalid"} ${errors[campo] && Style.errors} `} placeholder={placeholder} type={type} onChange={(e) => setValue(campo, e.target.value)}
                                        {...(register && { ...register(campo) })}
                                    />
                                    :
                                    <input
                                        data-fase={fase}
                                        // onInput={(e) => {
                                        //     const value = e.target.value;
                                        //     if (value.length > 4 && campo == 'numero_tramite') {
                                        //         e.target.value = value.slice(0, 4); // Limita a 4 caracteres
                                        //     }
                                        //     if (value.length > 15 && campo == 'telefono') {
                                        //         e.target.value = value.slice(0, 15); // Limita a 15 caracteres
                                        //     }
                                        //     if (value.length > 8 && campo == 'documento') {
                                        //         e.target.value = value.slice(0, 8); // Limita a 15 caracteres
                                        //     }
                                        // }} 
                                        name={campo}
                                        autoComplete='off'
                                        onKeyDown={(e) => {
                                            if (campo == 'correo_electronico_vrf')
                                                if ((e.ctrlKey || e.metaKey) && e.key == 'v') {
                                                    e.preventDefault()
                                                }
                                        }}
                                        style={{ width: widthInput && widthInput }}
                                        className={`  ${errors[campo] && "is-invalid"} ${errors[campo] && Style.errors}`} placeholder={placeholder} type={type} onChange={(e) => setValue(campo, e.target.value)}
                                        {...(register && { ...register(campo) })}
                                    />
            }
            {/* </div> */}
            {
                type != "file" &&
                <>
                    {
                        errors[campo]
                            ? <p data-fase={fase} className={`error text-danger `} >{errors[campo].message}</p>
                            : <div data-fase={fase} className='noError' />
                    }

                </>
            }

        </div>
    );
}
export default InputRHF;